
const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/contacto",
    exact: true,
    component: "ContactPage",
  },
  {
    path: "/aws",
    exact: true,
    component: "AwsPage",
  },
  {
    path: "*",
    component: "NotFound",
  },
];

export default routes;
